import React, { FunctionComponent, useContext } from 'react'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import { withStyles } from '@material-ui/core/styles'

import '../styles/Sort.scss'
import { useSort } from '../App'

const CustomRadio = withStyles({
  root: {
    padding: 3,
    marginRight: 4,
  },
})((props) => <Radio color='primary' {...props} />)

const Sort: FunctionComponent = () => {
  const { variable: sort, setVariable: setSort } = useContext(useSort)!

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSort(e.target.value)
  }

  return (
    <div className='Sort'>
      <FormLabel component='legend'>Sort by:</FormLabel>

      <RadioGroup name='gender' value={sort} onChange={(e) => handleChange(e)}>
        <FormControlLabel
          value='alphabetical'
          control={<CustomRadio />}
          label='A → Z'
        />
        <FormControlLabel
          value='categorical'
          control={<CustomRadio />}
          label='Categories'
        />
        <FormControlLabel
          value='random'
          control={<CustomRadio />}
          label='Random'
        />
      </RadioGroup>
    </div>
  )
}

export default Sort
